import { useCallback } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { SITE_I18N } from "../i18n/site";

const LANGS = ["en", "tr", "es", "pt", "ru"];

// Public-site translations: t("key", vars) from the shared dictionary; pick({en,tr,es,pt,ru}) for local structured copy.
export function useSiteT() {
    const { language } = useLanguage();
    const lang = LANGS.includes(language) ? language : "en";
    const t = useCallback((key, vars) => {
        const entry = SITE_I18N[key];
        let s = entry ? (entry[lang] ?? entry.en ?? key) : key;
        if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(String(v)); });
        return s;
    }, [lang]);
    const pick = useCallback((obj) => (obj?.[lang] ?? obj?.en), [lang]);
    return { t, pick, lang, language };
}
